import { render, staticRenderFns } from "./OfferSalesExpandableGroup.vue?vue&type=template&id=72fc2cc9&scoped=true"
import script from "./OfferSalesExpandableGroup.vue?vue&type=script&lang=js"
export * from "./OfferSalesExpandableGroup.vue?vue&type=script&lang=js"
import style0 from "./OfferSalesExpandableGroup.vue?vue&type=style&index=0&id=72fc2cc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc2cc9",
  null
  
)

export default component.exports